import { nwccDomain, wcisDomain } from "./nwcc-domains.js";

export function getQueryArgs() {
    let searchQuery = location.search?.substring(1);
    let hashQuery = location.hash;
    if (!searchQuery && !hashQuery) {
        return {};
    }
    let params = new URLSearchParams(searchQuery);
    let argsObj = paramsToObject(params.entries());
    const argKeys = Object.keys(argsObj);
    argKeys.forEach(function (argKey) {
        if (["true", "false"].includes(argsObj[argKey].toLowerCase())) {
            let bool = /true/i.test(argsObj[argKey]);
            argsObj[argKey] = bool;
        }
    });
    // Load any args after a hash too
    if (hashQuery) {
        let strings = hashQuery.replace("#", "").split("&");
        strings.forEach((keyvalue) => {
            let key, value;
            [key, value] = keyvalue.split("=");
            if (key && value) {
                argsObj[key] = value;
            } else if (key) {
                argsObj[key] = key;
            } else if (value) {
                argsObj[value] = value;
            }
        });
    }
    return argsObj;
}

function paramsToObject(entries) {
    const result = {};
    for (const [key, value] of entries) {
        if (key && value) {
            result[key] = value;
        }
    }
    return result;
}

export function getBasinStates() {
    return [
        { name: "Alaska", abbr: "AK" },
        { name: "Arizona", abbr: "AZ" },
        { name: "California", abbr: "CA" },
        { name: "Colorado", abbr: "CO" },
        { name: "Idaho", abbr: "ID" },
        { name: "Montana", abbr: "MT" },
        { name: "Nevada", abbr: "NV" },
        { name: "New Mexico", abbr: "NM" },
        { name: "Oregon", abbr: "OR" },
        { name: "Utah", abbr: "UT" },
        { name: "Washington", abbr: "WA" },
        { name: "Wyoming", abbr: "WY" },
    ];
}

export function getStates() {
    return [
        { name: "Alabama", abbr: "AL" },
        { name: "Alaska", abbr: "AK" },
        { name: "Arizona", abbr: "AZ" },
        { name: "Arkansas", abbr: "AR" },
        { name: "American Samoa", abbr: "AS" },
        { name: "California", abbr: "CA" },
        { name: "Colorado", abbr: "CO" },
        { name: "Connecticut", abbr: "CT" },
        { name: "Delaware", abbr: "DE" },
        { name: "District Of Columbia", abbr: "DC" },
        { name: "Florida", abbr: "FL" },
        { name: "Georgia", abbr: "GA" },
        { name: "Guam", abbr: "GU" },
        { name: "Hawaii", abbr: "HI" },
        { name: "Idaho", abbr: "ID" },
        { name: "Illinois", abbr: "IL" },
        { name: "Indiana", abbr: "IN" },
        { name: "Iowa", abbr: "IA" },
        { name: "Kansas", abbr: "KS" },
        { name: "Kentucky", abbr: "KY" },
        { name: "Louisiana", abbr: "LA" },
        { name: "Maine", abbr: "ME" },
        { name: "Maryland", abbr: "MD" },
        { name: "Massachusetts", abbr: "MA" },
        { name: "Michigan", abbr: "MI" },
        { name: "Minnesota", abbr: "MN" },
        { name: "Mississippi", abbr: "MS" },
        { name: "Missouri", abbr: "MO" },
        { name: "Montana", abbr: "MT" },
        { name: "Nebraska", abbr: "NE" },
        { name: "Nevada", abbr: "NV" },
        { name: "New Hampshire", abbr: "NH" },
        { name: "New Jersey", abbr: "NJ" },
        { name: "New Mexico", abbr: "NM" },
        { name: "New York", abbr: "NY" },
        { name: "North Carolina", abbr: "NC" },
        { name: "North Dakota", abbr: "ND" },
        { name: "Northern Mariana Islands", abbr: "MP" },
        { name: "Ohio", abbr: "OH" },
        { name: "Oklahoma", abbr: "OK" },
        { name: "Oregon", abbr: "OR" },
        { name: "Pennsylvania", abbr: "PA" },
        { name: "Puerto Rico", abbr: "PR" },
        { name: "Rhode Island", abbr: "RI" },
        { name: "South Carolina", abbr: "SC" },
        { name: "South Dakota", abbr: "SD" },
        { name: "Tennessee", abbr: "TN" },
        { name: "Texas", abbr: "TX" },
        { name: "US Virgin Islands", abbr: "VI" },
        { name: "Utah", abbr: "UT" },
        { name: "Vermont", abbr: "VT" },
        { name: "Virginia", abbr: "VA" },
        { name: "Washington", abbr: "WA" },
        { name: "West Virginia", abbr: "WV" },
        { name: "Wisconsin", abbr: "WI" },
        { name: "Wyoming", abbr: "WY" },
    ];
}

export function getEasternRegions() {
    return [
        { name: "Caribbean Region", abbr: "21" },
        { name: "Great Lakes Region", abbr: "04" },
        { name: "Lower Mississippi Region", abbr: "08" },
        { name: "Mid Atlantic Region", abbr: "02" },
        { name: "New England Region", abbr: "01" },
        { name: "Ohio Region", abbr: "05" },
        { name: "Souris-Red-Rainy Region", abbr: "09" },
        { name: "South Atlantic-Gulf Region", abbr: "03" },
        { name: "Tennessee Region", abbr: "06" },
        { name: "Texas-Gulf Region", abbr: "12" },
        { name: "Upper Mississippi Region", abbr: "07" },
    ];
}

export function getWesternRegions() {
    return [
        { name: "Alaska Region", abbr: "19" },
        { name: "Arkansas-White-Red Region", abbr: "11" },
        { name: "California Region", abbr: "18" },
        { name: "Great Basin Region", abbr: "16" },
        { name: "Hawaii Region", abbr: "20" },
        { name: "Lower Colorado Region", abbr: "15" },
        { name: "Missouri Region", abbr: "10" },
        { name: "Pacific Northwest Region", abbr: "17" },
        { name: "Rio Grande Region", abbr: "13" },
        { name: "Upper Colorado Region", abbr: "14" },
    ];
}

export function getLabelWithIcon(name, icon) {
    let mobileFriendlySVG =
        "M4 6h18V4H4c-1.1 0-2 .9-2 2v11H0v3h14v-3H4V6zm19 2h-6c-.55 0-1 .45-1 1v10c0 .55.45 1 1 1h6c.55 0 1-.45 1-1V9c0-.55-.45-1-1-1zm-1 9h-4v-7h4v7z";
    let desktopOnlySVG =
        "M20 18c1.1 0 1.99-.9 1.99-2L22 6c0-1.1-.9-2-2-2H4c-1.1 0-2 .9-2 2v10c0 1.1.9 2 2 2H0v2h24v-2h-4zM4 6h16v10H4V6z";
    let options = {
        mobile: mobileFriendlySVG,
        desktop: desktopOnlySVG,
    };
    let path = "";
    if (Object.keys(options).includes(icon.toLowerCase())) {
        path = options[icon];
    } else {
        return name;
    }
    const svg = `
        <svg
            class="fsa-icon fsa-icon--size-2"
            aria-hidden="true"
            focusable="false"
            role="img"
            fill="#494440"
            xmlns="http://www.w3.org/2000/svg"
            width="24"
            height="24"
            viewBox="0 0 24 24"
        >
            <path d="${path}"></path>
        </svg >
        `;
    return `${name}${svg || ""}`;
}

export function getWebserviceApplications() {
    return [
        {
            name: "SOAP Webservice",
            path: "/awdbWebService/webservice/testwebservice.jsf?webserviceName=/awdbWebService",
            domain: "wcis",
        },
        {
            name: "RESTful Webservice",
            path: "/awdbRestApi/swagger-ui.html",
            domain: "wcis",
        },
    ];
}

export function getBasinReportApplications() {
    return [
        {
            name: getLabelWithIcon("Update Reports", "desktop"),
            path: "/reports/SelectUpdateReport.html",
            domain: "wcis",
        },
        {
            name: getLabelWithIcon("Monthly Reports", "mobile"),
            path: "/basin-reports/",
            domain: "nwcc",
        },
    ];
}

export function getSiteReportApplications() {
    let siteReportApps = [
        {
            name: getLabelWithIcon("Report Generator", "desktop"),
            path: "/reportGenerator/",
            domain: "wcis",
        },
        {
            name: getLabelWithIcon("Data Generator", "mobile"),
            path: "/",
            domain: "nwcc",
        },
        {
            name: getLabelWithIcon("Site Pages", "desktop"),
            path: "/site-pages/",
            domain: "nwcc",
        },
    ];
    return siteReportApps;
}

export function navBtnClick(btn) {
    const _self = btn;
    const _component = _self.closest(".fsa-nav-global");
    const _listItem = _self.closest(".fsa-nav-global__list-item");
    const _target = _listItem.querySelector(".fsa-nav-global__sub-menu");
    const _currentlyActiveTab = _component.querySelector('.fsa-nav-global__link[aria-expanded="true"]');
    const _currentlyActiveFlyout = _component.querySelector('.fsa-nav-global__sub-menu[aria-hidden="false"]');
    const _menuState = _self.getAttribute("aria-expanded");

    if (_currentlyActiveTab) {
        _currentlyActiveTab.setAttribute("aria-expanded", "false");
        _currentlyActiveFlyout.setAttribute("aria-hidden", "true");
    }

    if (_menuState == "true") {
        _self.setAttribute("aria-expanded", "false");
        _target.setAttribute("aria-hidden", "true");
    } else {
        _self.setAttribute("aria-expanded", "true");
        _target.setAttribute("aria-hidden", "false");
    }
}

export function navBtnFocus() {
    if (document.querySelector('.fsa-nav-global__link[aria-expanded="true"]')) {
        document.querySelector('.fsa-nav-global__link[aria-expanded="true"]').setAttribute("aria-expanded", "false");
        document.querySelector('.fsa-nav-global__sub-menu[aria-hidden="false"]').setAttribute("aria-hidden", "true");
    }
}

export function navBtnBlur(btn, event) {
    const _self = btn;
    const _component = _self.closest(".fsa-nav-global");
    const _listItem = _self.closest(".fsa-nav-global__list-item");
    const _list = _self.closest(".fsa-nav-global__list");
    const _target = _listItem.querySelector(".fsa-nav-global__sub-menu");
    const _currentlyActiveTab = _component.querySelector('.fsa-nav-global__link[aria-expanded="true"]');
    const _currentlyActiveFlyout = _component.querySelector('.fsa-nav-global__sub-menu[aria-hidden="false"]');
    const _menuState = _self.getAttribute("aria-expanded");
    const clickedMenu = _list.contains(event.relatedTarget);

    if (!clickedMenu) {
        if (_currentlyActiveTab) {
            _currentlyActiveTab.setAttribute("aria-expanded", "false");
            _currentlyActiveFlyout.setAttribute("aria-hidden", "true");
        }

        if (_menuState == "true") {
            _self.setAttribute("aria-expanded", "false");
            _target.setAttribute("aria-hidden", "true");
        }
    }
}

export function loadNav(hideWesternRegions = true, hideEasternRegions = false) {
    const states = getStates();
    const basinStates = getBasinStates();
    const eastRegions = getEasternRegions();
    const westRegions = getWesternRegions();
    const webServices = getWebserviceApplications();
    const siteReports = getSiteReportApplications();
    const basinReports = getBasinReportApplications();
    const shadowRoot = document.getElementsByTagName("nwcc-header")[0].shadowRoot;
    const sitePlotsUl = shadowRoot.getElementById("site-plots-nav-ul");
    const basinPlotsUl = shadowRoot.getElementById("basin-plots-nav-ul");
    const eastRegionPlotsUl = shadowRoot.getElementById("east-region-plots-nav-ul");
    hideEasternRegions || eastRegionPlotsUl.parentElement.classList.add("fsa-hide");
    const westRegionPlotsUl = shadowRoot.getElementById("west-region-plots-nav-ul");
    hideWesternRegions || westRegionPlotsUl.parentElement.classList.add("fsa-hide");
    const forecastPlotsUl = shadowRoot.getElementById("forecast-plots-nav-ul");
    const forecastEvolutionPlotsUl = shadowRoot.getElementById("forecast-evo-plots-nav-ul");
    const webServicesUl = shadowRoot.getElementById("web-services-nav-ul");
    const siteReportsUl = shadowRoot.getElementById("site-reports-nav-ul");
    const basinReportsUl = shadowRoot.getElementById("basin-reports-nav-ul");
    const navBtns = shadowRoot.querySelectorAll(".fsa-nav-global__link--has-sub-menu");

    navBtns.forEach(function (navBtn) {
        navBtn.addEventListener("click", function (e) {
            navBtnClick(this);
        });
        navBtn.addEventListener("focus", function (e) {
            navBtnFocus();
        });
        navBtn.addEventListener("blur", function (e) {
            navBtnBlur(this, e);
        });
    });

    const sitePlotsBaseUrl = `${nwccDomain}/site-plots/`;
    const basinPlotsBaseUrl = `${nwccDomain}/basin-plots/`;
    const regionPlotsBaseUrl = `${nwccDomain}/huc-plots/`;
    const forecastPlotsBaseUrl = `${nwccDomain}/forecast-plots/`;
    const forecastEvolutionPlotsBaseUrl = `${nwccDomain}/forecast-evolution/`;

    states.forEach(function (item) {
        const stateListItem = document.createElement("li");
        stateListItem.className = "fsa-nav-global__sub-menu-item";
        const stateLink = document.createElement("a");
        stateLink.className = "fsa-nav-global__sub-menu-link";
        stateLink.href = `${sitePlotsBaseUrl}?state=${item["abbr"]}`;
        stateLink.innerHTML = item["name"];
        stateListItem.appendChild(stateLink);
        sitePlotsUl.appendChild(stateListItem);
    });

    basinStates.forEach(function (item) {
        const stateListItem = document.createElement("li");
        stateListItem.className = "fsa-nav-global__sub-menu-item";
        const stateLink = document.createElement("a");
        stateLink.className = "fsa-nav-global__sub-menu-link";
        stateLink.href = `${basinPlotsBaseUrl}?state=${item["abbr"]}`;
        stateLink.innerHTML = item["name"];
        stateListItem.appendChild(stateLink);
        basinPlotsUl.appendChild(stateListItem);
    });

    eastRegions.forEach(function (item) {
        const regionListItem = document.createElement("li");
        regionListItem.className = "fsa-nav-global__sub-menu-item";
        const regionLink = document.createElement("a");
        regionLink.className = "fsa-nav-global__sub-menu-link";
        regionLink.href = `${regionPlotsBaseUrl}?huc=${item["abbr"]}`;
        regionLink.innerHTML = item["name"];
        regionListItem.appendChild(regionLink);
        eastRegionPlotsUl.appendChild(regionListItem);
    });

    westRegions.forEach(function (item) {
        const regionListItem = document.createElement("li");
        regionListItem.className = "fsa-nav-global__sub-menu-item";
        const regionLink = document.createElement("a");
        regionLink.className = "fsa-nav-global__sub-menu-link";
        regionLink.href = `${regionPlotsBaseUrl}?hucFilter=${item["abbr"]}`;
        regionLink.innerHTML = item["name"];
        regionListItem.appendChild(regionLink);
        westRegionPlotsUl.appendChild(regionListItem);
    });

    basinStates.forEach(function (item) {
        const stateListItem = document.createElement("li");
        stateListItem.className = "fsa-nav-global__sub-menu-item";
        const stateLink = document.createElement("a");
        stateLink.className = "fsa-nav-global__sub-menu-link";
        stateLink.href = `${forecastPlotsBaseUrl}#state=${item["abbr"]}`;
        stateLink.innerHTML = item["name"];
        stateListItem.appendChild(stateLink);
        forecastPlotsUl.appendChild(stateListItem);

        const stateEvoListItem = document.createElement("li");
        stateEvoListItem.className = "fsa-nav-global__sub-menu-item";
        const stateEvoLink = document.createElement("a");
        stateEvoLink.className = "fsa-nav-global__sub-menu-link";
        stateEvoLink.href = `${forecastEvolutionPlotsBaseUrl}?state=${item["abbr"]}`;
        stateEvoLink.innerHTML = item["name"];
        stateEvoListItem.appendChild(stateEvoLink);
        forecastEvolutionPlotsUl.appendChild(stateEvoListItem);
    });

    webServices.forEach(function (item) {
        const domain = item["domain"] === "wcis" ? wcisDomain : nwccDomain;
        const webServiceListItem = document.createElement("li");
        webServiceListItem.className = "fsa-nav-global__sub-menu-item";
        const webServiceLink = document.createElement("a");
        webServiceLink.className = "fsa-nav-global__sub-menu-link";
        webServiceLink.href = domain + item["path"];
        webServiceLink.innerHTML = item["name"];
        webServiceListItem.appendChild(webServiceLink);
        webServicesUl.appendChild(webServiceListItem);
    });

    siteReports.forEach(function (item) {
        const domain = item["domain"] === "wcis" ? wcisDomain : nwccDomain;
        const siteReportListItem = document.createElement("li");
        siteReportListItem.className = "fsa-nav-global__sub-menu-item";
        const siteReportLink = document.createElement("a");
        siteReportLink.className = "fsa-nav-global__sub-menu-link";
        siteReportLink.href = domain + item["path"];
        siteReportLink.innerHTML = item["name"];
        siteReportListItem.appendChild(siteReportLink);
        siteReportsUl.appendChild(siteReportListItem);
    });

    basinReports.forEach(function (item) {
        const domain = item["domain"] === "wcis" ? wcisDomain : nwccDomain;
        const basinReportListItem = document.createElement("li");
        basinReportListItem.className = "fsa-nav-global__sub-menu-item";
        const basinReportLink = document.createElement("a");
        basinReportLink.className = "fsa-nav-global__sub-menu-link";
        basinReportLink.href = domain + item["path"];
        basinReportLink.innerHTML = item["name"];
        basinReportListItem.appendChild(basinReportLink);
        basinReportsUl.appendChild(basinReportListItem);
    });
}
